module.exports = __webpack_public_path__ + "static/media/Remus Lupin 3.7de81a63.jpg";